import FullWidthLayout from "@/layouts/FullWidthLayout";
import SpecSheetsTable from "kinnect-front/CounterSales/SpecSheets/SpecSheetsTable";
import { Pageable } from "kinnect-mixins";
import { KTextField } from "kinnect-general";
import {
	VCard,
	VSheet
} from "vuetify/lib";

export default {
	name: "SpecSheetsPage",

	metaInfo: { title: "Spec Sheets" },

	mixins: [ Pageable ],

	data: () => ( {
		search: ""
	} ),

	computed: {
		toolbarActions() {
			if ( this.$can( "add_spec_sheets" ) ) {
				return {
					icon: "add_circle",
					text: "Add Spec Sheet",
					to: { name: "specSheetAdd" },
					tooltip: "Add a new spec sheet"
				};
			}
		}
	},

	render() {
		return <FullWidthLayout>
			<VCard>
				<VSheet class="pa-3" color="primary" tile>
					<KTextField
						clearable
						dark
						flat
						hideDetails
						label="Search"
						prependInnerIcon="search"
						soloInverted
						vModel={this.search}
					></KTextField>
				</VSheet>

				<SpecSheetsTable search={this.search}></SpecSheetsTable>
			</VCard>
		</FullWidthLayout>;
	}
};
